import { useEffect, useState, useRef } from 'react';
import Flow from '@flowjs/flow.js';
import { ENV } from './env';
import { getJwtToken } from 'features/auth';
import { useSelector } from 'react-redux';
import type { Flow as FlowType, FlowOptions, FlowFile } from 'flowjs';
import { FilesComponentsProps } from 'components/FileUploader/files.types';

export type ApiFile = {
    code: string;
    id: number;
    level: 'private' | 'public';
    label?: string;
    observation?: string;
    online: boolean;
    token: string;
    filename: string;
    original_filename: string;
    mime_type: string;
    size: number;
    view_link: string;
    created_at: string;
};

export type ApiResponseFile = {
    code: string;
    data: ApiFile;
    status: number
}

export type UseFlowTsProps = Pick<FilesComponentsProps, 'setFiles' | 'onSuccess'>;

export const useFlowTs = ({ setFiles, onSuccess }: UseFlowTsProps) => {
    const jwt = useSelector(getJwtToken);
    const [flow, setFlow] = useState<FlowType | null>(null);
    const flowRef = useRef<FlowType | null>(null);

    useEffect(() => {
        if (!jwt) return;

        const options: FlowOptions = {
            target: `${ENV.API_URL}/cdn/file/import`,
            query: { jwt },
            chunkSize: 1024 * 1024 * 10,
            permanentErrors: [400, 401, 404, 500],
            maxChunkRetries: 5,
            chunkRetryInterval: 1000
        };

        const flowInstance = new Flow(options);

        flowRef.current = flowInstance;
        setFlow(flowInstance);

        const addFile = (apiFile: string) => {
            setFiles((prevFiles) => [...prevFiles, JSON.parse(apiFile).data]);
        };

        flowInstance.on('fileAdded', (flowFile: FlowFile) => {
            setTimeout(() => {
                flowFile.flowObj.upload();
            }, 0);
        });
        // flowInstance.on('fileRemoved', updateFiles);
        flowInstance.on('fileSuccess', (_file: FlowFile, apiFile: string) => {
            addFile(apiFile);
            onSuccess && onSuccess(JSON.parse(apiFile).data);
        });
        // flowInstance.on('fileError', updateFiles);

        return () => {
            if (flowRef.current) {
                flowRef.current.off('fileAdded');
                flowRef.current.off('fileSuccess');
            }
        };
    }, [jwt, onSuccess, setFiles]);

    return {
        flow
    };
};
